angular.module('common.services').factory('devicesFactoryV2', [
  '$http',
  '$filter',
  '$localStorage',
  '$q',
  function ($http, $filter, $localStorage, $q) {
    this.getRecordsAvailability = function (
      serialNumber,
      startTime,
      endTime,
      canceller
    ) {
      const request = {
        method: 'GET',
        url: `${V2_BASEURL}/devices/${serialNumber}/recording-ranges`,
        headers: {
          'x-media-token': $localStorage.userMediaAccessToken
        },
        params: { start: startTime, end: endTime }
      }
      if (canceller) {
        request.timeout = canceller.promise
      }
      return $http(request).then(response => {
        return response.data.data.map(item => ({
          camera_id: item.cameraId,
          intervals: item.intervals.map(interval => ({
            start_time: new Date(interval.start).getTime() / 1000,
            end_time: new Date(interval.end).getTime() / 1000
          }))
        }))
      })
    }

    return this
  }
])
